import axios from "axios";
import { StringLiteralType } from "typescript";

class UseGE {
  async getCategory(ge: string) {
    return await axios.post(`use-ge/getge`, { ge });
  }
}
export default new UseGE();
